export default "__VITE_ASSET__hiESGhrM__"